<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <div>
          <IzbirnikStranke v-on:osvezitevIzbranIdStranka="PreverjanjeClanstvo"
                           :selectorPermissions="selectorPermissions"
                           :disabled="preverjanjeClanstva"/>
        </div>
      </div>
    </div>
    <div style="clear: both"/>
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine">
        <div>
          <p class="open-sans-30pt">
            T-2 Klub - Svet ugodnih nakupov
          </p>
        </div>
        <div v-if="!vclanjen && !preverjanjeClanstva">
          <ClanstvoKlubInfo
            :izbranaStranka="izbranaStranka"
            v-on:ponovniKlicZaPridobivanjeVclanitve="PreverjanjeClanstvo"/>
        </div>
        <div v-else>
          <MojKlub :izbranaStranka="izbranaStranka"
                   :steviloNarocil="steviloNarocil"
                   :steviloTock="steviloTock"
                   :podatkiOclanu="podatkiOclanu"
                   :pridobivanjePodatkovClana="pridobivanjePodatkovClana"
                   v-on:ponovniKlicZaPridobivanjeVclanitve="PreverjanjeClanstvo"/>
          <MojaNarocila :izbranaStranka="izbranaStranka"
                        :vclanjen="vclanjen"
                        :osnovniSeznamZgodovineNakupov="osnovniSeznamZgodovineNakupov"
                        :osnovniSeznamZgodovineTock="osnovniSeznamZgodovineTock"/>

<!--          ZAKOMENTIRANO ZA KASNEJSO UPORABO -->
<!--          <el-tabs type="border-card" @tab-click="HandleTabClick" value="t1" style="padding-top: 30px">-->
<!--            <el-tab-pane label="Moj T-2 Klub" name="t1" ref="t1">-->
<!--              <MojKlub :izbranaStranka="izbranaStranka"-->
<!--                       :steviloNarocil="steviloNarocil"-->
<!--                       :steviloTock="steviloTock"-->
<!--                       :podatkiOclanu="podatkiOclanu"-->
<!--                       v-on:ponovniKlicZaPridobivanjeVclanitve="PreverjanjeClanstvo"/>-->
<!--            </el-tab-pane>-->
<!--            <el-tab-pane label="Moja naročila" name="t2" ref="t2">-->
<!--              <MojaNarocila :izbranaStranka="izbranaStranka"-->
<!--                            :vclanjen="vclanjen"-->
<!--                            :osnovniSeznamZgodovineNakupov="osnovniSeznamZgodovineNakupov"-->
<!--                            :osnovniSeznamZgodovineTock="osnovniSeznamZgodovineTock"/>-->
<!--            </el-tab-pane>-->
<!--          </el-tabs>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'
import {ZgodovinaTock} from 'src/assets/js/globalne_funkcije/Klub/ZgodovinaTock'
import {PridobivanjeTock} from 'src/assets/js/globalne_funkcije/Klub/PridobivanjeTock'
import {PridobivanjeZgodovineNarocil} from 'src/assets/js/globalne_funkcije/Klub/PridobivanjeZgodovineNarocil.js'
import MojaNarocila from './T2klub/MojaNarocila.vue'
import MojKlub from './T2klub/MojKlub.vue'
import ClanstvoKlubInfo from './T2klub/ClanstvoKlubInfo.vue'
import {Checkbox, Button, Option, Select, Pagination, TabPane, Tabs} from 'element-ui'
import ClientAgent from '../../../../assets/js/clientAgent.js'

export default {
  name: 'T-2Klub',
  mixins: [PridobivanjeZgodovineNarocil, PridobivanjeTock, ZgodovinaTock, PrikazVsebine],
  data () {
    return {
      activetab: 't1',
      clientAgent: null,
      seznamNarocnin: [],
      idStranka: '',
      izbranSap: '',
      vclanjen: false,
      preverjanjeClanstva: true,
      osvezitevStevec: 0,
      izbranaStranka: '',
      steviloNarocil: 0,
      steviloTock: 0,
      osnovniSeznamZgodovineNakupov: [],
      osnovniSeznamZgodovineTock: [],
      podatkiOclanu: {},
      selectorPermissions: ['STRANKE'],
      pridobivanjePodatkovClana: false
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
  },
  components: {
    PridobivanjeZgodovineNarocil,
    PridobivanjeTock,
    ZgodovinaTock,
    'IzbirnikStranke': IzbirnikStranke,
    'ClanstvoKlubInfo': ClanstvoKlubInfo,
    'MojKlub': MojKlub,
    'MojaNarocila': MojaNarocila,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    [Option.name]: Option,
    [Select.name]: Select,
    [Pagination.name]: Pagination,
    [TabPane.name]: TabPane,
    [Tabs.name]: Tabs
  },
  methods: {
    HandleTabClick (tab) {
      this.activetab = tab.name
    },
    PreverjanjeClanstvo (prenosniIdStranka) {
      this.preverjanjeClanstva = true
      if (prenosniIdStranka !== '') {
        this.pridobivanjePodatkovClana = true
        this.izbranaStranka = prenosniIdStranka
        let param = []
        param.push('idStranka=' + prenosniIdStranka)
        this.clientAgent.postWsRequest(this,
          'klub/klubInfo?',
          param,
          prenosniIdStranka,
          'SetPreverjanjeClanstvo',
          '')
      }
    },
    SetPreverjanjeClanstvo (podatki) {
      this.podatkiOclanu = {}
      this.podatkiOclanu = podatki.data.profil
      this.vclanjen = podatki.data.clanstvo
      if (this.vclanjen === true) {
        this.vclanjen = true
        let param = {}
        param.vmesnik = this
        param.prenesenIzbranId = this.izbranaStranka
        param.samoPomembno = '1'
        this.GetZgodovinaNarocil(param)
        this.PreveriStanjeTock(param)
        this.GetZgodovinaTock(param)
      } else {
        this.vclanjen = false
      }
      this.preverjanjeClanstva = false
      this.pridobivanjePodatkovClana = false
    },
    PridobiPodatkeZgodovineNarocilKlub (prenosniParam, podatkiZgodovineNarocil) {
      this.steviloNarocil = podatkiZgodovineNarocil.length
      this.osnovniSeznamZgodovineNakupov = podatkiZgodovineNarocil
    },
    PridobiPodatkeTockeKlub (podatki, steviloTock) {
      this.steviloTock = steviloTock
    },
    PridobiPodatkeZgodovineTockKlub (prenosniParam, podatkiZgodovinaTockKlub) {
      this.osnovniSeznamZgodovineTock = podatkiZgodovinaTockKlub
    }
  }
}
</script>
<style scoped src="../../../../../static/css/MojT-2/T2Klub/T2Klub.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/T2klub.vue